import React, { FC } from 'react'
import Icon from '../Icon'
import styles from './Back.module.css'

interface IBackProps {
  goBack?: () => void
}

const Back: FC<IBackProps> = (props) => {
  return (
    <button className={styles.backButton} onClick={props.goBack}>
      <Icon hash="arrow-left" size={32} />
    </button>
  )
}

export default Back
